module.exports = __webpack_public_path__ + "soap.jpg?a1d3245db223c079eadd3c451dbcb03d";